module.exports = __webpack_public_path__ + "img/RFR.273fc1a4.svg";